<form [formGroup]="form">
  <div class="card mb-3 bg-2">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12 col-md-4">
          <lib-autocomplete [schema]="grupocarteiraSchema"></lib-autocomplete>
        </div>

        <div class="col-sm-12 col-md-4">
          <lib-autocomplete [schema]="carteiraSchema"></lib-autocomplete>
        </div>
      </div>
    </div>

    <div class="card-footer clearfix">
      <div class="d-flex flex-end justify-content-end">
        <div class="pr-3">
          <button
            title="Pesquisar"
            label="Pesquisar"
            type="submit"
            color="primary"
            mat-raised-button
            (click)="totalRegistros = 0; page$.next(1); pesquisar(this.form)"
            [disabled]="form.invalid || (loading$ | async)"
            aria-label="left"
          >
            <loading-icon [btnLabel]="'Pesquisar'" [loading]="loading$ | async"></loading-icon>
          </button>
        </div>

        <button mat-raised-button [matMenuTriggerFor]="menuExportarRegra" [disabled]="(loadingExport$ | async) || !exportEnabled">
          <loading-icon [btnLabel]="'Exportar'" [loading]="loadingExport$ | async"></loading-icon>
          <span class="caret"></span>
        </button>

        <mat-menu #menuExportarRegra="matMenu">
          <button mat-menu-item (click)="exportarPdf()">
            <span>PDF</span>
          </button>

          <button mat-menu-item (click)="exportarXls()">
            <span>Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</form>

<app-total-table (onChange)="onChangeTotalPagina($event)" [totalRegistros]="this.totalRegistros"></app-total-table>

<table class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
  <thead>
    <tr>
      <th>Grupo</th>

      <th>Carteira</th>

      <th class="text-center">Ações</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let associacaoGrupoCarteira of associacoesGrupoCarteira">
      <td>{{associacaoGrupoCarteira.nomeGrupoCarteira}}</td>

      <td>{{associacaoGrupoCarteira.nomeCarteira}}</td>

      <td class="pt-1 pb-1" style="width: 250px;">
        <div class="d-flex flex-row justify-content-center">
          <div class="pr">
            <button mat-icon-button color="warn" type="button" (click)="openDeleteDialog(associacaoGrupoCarteira)" title="Excluir">
              <i class="fas fa-trash" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div class="d-flex justify-content-center mb-5">
  <maps-pagination
    [items]="paginationTotalPage"
    [pageNumber]="page$"
    *ngIf="paginationTotalPage && paginationTotalPage > 0"
    (pageSend)="receivePage($event)"
  >
  </maps-pagination>
</div>
